import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCircleX: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCircleX"><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM9 7.93934L7.93934 9L10.9393 12L7.93934 15L9 16.0607L12 13.0607L15 16.0607L16.0607 15L13.0607 12L16.0607 9L15 7.93934L12 10.9393L9 7.93934Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCircleX;
